import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import UndoIcon from '@mui/icons-material/Undo';
import { EStatusLabel, StatusLabelProps } from 'design-system/StatusLabel/types';

import { EOrderStatus } from './enums';

export const statusDictionary: Record<EOrderStatus, StatusLabelProps> = {
    [EOrderStatus.unpaid]: {
        text: 'Pending',
        prefixIcon: <AccessTimeIcon />,
        status: EStatusLabel.PENDING
    },
    [EOrderStatus.created]: {
        text: 'Created',
        prefixIcon: <AccessTimeIcon />,
        status: EStatusLabel.SUCCESS
    },
    [EOrderStatus.payment_pending]: {
        text: 'Payment Pending',
        prefixIcon: <AccessTimeIcon />,
        status: EStatusLabel.PENDING
    },
    [EOrderStatus.payment_succeed]: {
        text: 'Payment Succeed',
        prefixIcon: <CheckCircleOutlineIcon />,
        status: EStatusLabel.SUCCESS
    },
    [EOrderStatus.payment_failed]: {
        text: 'Payment Failed',
        prefixIcon: <DoNotDisturbIcon />,
        status: EStatusLabel.CANCELED
    },
    [EOrderStatus.payment_refund_pending]: {
        text: 'Refund Pending',
        prefixIcon: <AccessTimeIcon />,
        status: EStatusLabel.PENDING
    },
    [EOrderStatus.payment_refund_requires_action]: {
        text: 'Refund Requires Action',
        prefixIcon: <AccessTimeIcon />,
        status: EStatusLabel.PENDING
    },
    [EOrderStatus.payment_refunded]: {
        text: 'Refunded',
        prefixIcon: <UndoIcon />,
        status: EStatusLabel.CANCELED
    },
    [EOrderStatus.payment_refund_failed]: {
        text: 'Refund Failed',
        prefixIcon: <DoNotDisturbIcon />,
        status: EStatusLabel.CANCELED
    },
    [EOrderStatus.payment_refund_canceled]: {
        text: 'Refund Canceled',
        prefixIcon: <DoNotDisturbIcon />,
        status: EStatusLabel.CANCELED
    },
    [EOrderStatus.payment_refund_cancelled]: {
        text: 'Refund Cancelled',
        prefixIcon: <DoNotDisturbIcon />,
        status: EStatusLabel.CANCELED
    },
    [EOrderStatus.payment_canceled]: {
        text: 'Payment Canceled',
        prefixIcon: <DoNotDisturbIcon />,
        status: EStatusLabel.CANCELED
    },
    [EOrderStatus.charge_pending]: {
        text: 'Charge Pending',
        prefixIcon: <AccessTimeIcon />,
        status: EStatusLabel.PENDING
    },
    [EOrderStatus.charge_succeed]: {
        text: 'Succeeded',
        prefixIcon: <CheckCircleOutlineIcon />,
        status: EStatusLabel.SUCCESS
    },
    [EOrderStatus.charge_failed]: {
        text: 'Charge Failed',
        prefixIcon: <DoNotDisturbIcon />,
        status: EStatusLabel.CANCELED
    },
    [EOrderStatus.payment_dispute_open]: {
        text: 'Dispute Open',
        prefixIcon: <AccessTimeIcon />,
        status: EStatusLabel.PENDING
    },
    [EOrderStatus.payment_dispute_lost]: {
        text: 'Dispute Lost',
        prefixIcon: <DoNotDisturbIcon />,
        status: EStatusLabel.CANCELED
    },
    [EOrderStatus.payment_dispute_won]: {
        text: 'Dispute Won',
        prefixIcon: <CheckCircleOutlineIcon />,
        status: EStatusLabel.SUCCESS
    },
    [EOrderStatus.payment_dispute_evidence_submitted]: {
        text: 'Evidence Submitted',
        prefixIcon: <ArrowForwardIcon />,
        status: EStatusLabel.SUCCESS
    },
    [EOrderStatus.payment_dispute_inquiry_open]: {
        text: 'Inquiry Open',
        prefixIcon: <AccessTimeIcon />,
        status: EStatusLabel.PENDING
    },
    [EOrderStatus.payment_dispute_inquiry_evidence_submitted]: {
        text: 'Inquiry Evidence Submitted',
        prefixIcon: <ArrowForwardIcon />,
        status: EStatusLabel.SUCCESS
    },
    [EOrderStatus.payment_dispute_inquiry_won]: {
        text: 'Inquiry Won',
        prefixIcon: <CheckCircleOutlineIcon />,
        status: EStatusLabel.SUCCESS
    },
    [EOrderStatus.payment_expired]: {
        text: 'Payment Expired',
        prefixIcon: <DoNotDisturbIcon />,
        status: EStatusLabel.CANCELED
    }
};

export const chargeFailedFreeOrder = 'Failed';

